<template>
  <el-scrollbar style="height:100%" class="el-menu-scrollbar__wrap" v-if="Visible">
    <el-tree
      :data="treeData"
      :props="props"
      :load="loadNode"
      lazy
      :show-checkbox="isCheck || (isdoorMultiple && !onlyuser && !radio)"
      node-key="organizationId"
      highlight-current
      check-strictly
      ref="tree"
      :default-checked-keys="checkedKeys"
      @check-change="handleCheckChange"
      @current-change="handleCurrentChange"
      @node-click="handleNodeClick"
      :expand-on-click-node="false"
      :check-on-click-leaf="!isCheck"
      :filter-node-method="filterNode">
      <template #default="{ node }">
        <span class="custom-tree-node ellipsis">
          <el-tooltip effect="dark" :content="node.label" placement="top">
            <span>{{ dealShowName(node) }}</span>
          </el-tooltip>
        </span>
      </template>
    </el-tree>
  </el-scrollbar>
  
</template>

<script>
import { getequalorglist, getapiorganizationlist, getopenorganizationlist } from '@/port/clientSide/multipleChoice'
import { getOrgShowName } from '@/api/global'
export default {
  name: 'organizeChoice',
  data () {
    return {
      Visible: false,
      props: {
          label: 'name',
          children: 'children',
          isLeaf: 'leaf'
        },
      apiUrl: false, //默认为客户端 true为服务端
      option: null, // 有选项，就不走接口
      onlyuser: false, //只选用户
      leaf: false, // true不能有下级
      radio:false,
      checkedKeys:[],// 默认选择的，勾选使用
      checkedArr:[], //选中的数据 this.$refs.tree.setCheckedKeys(this.checkedKeys);
      pargam: {},
      treeData:[],
      node_had:null,
      resolve_had:null,
      isSpace: false, // 是否从空间进入
      isUpace: false, // 是否从空间进入
      lookRMSIsOrg: null, // 组织控件-组织查看范围
      orgLabel: null, // 组织控件-可选择标签
      orgEqual: false, // 组织控件-组织查看范围-true表示选择：同级组织
      isdoorMultiple: true, // 是否是门户进来多选
      iManageIt: [], // 组织我管理的标签
      isLook: 0, // //查看范围。1:本部门不含子部门,2:本部门及其子部门,3:全部部门,4:自定义,5:无,6: 我管理的,
      allOrgList: [], // 所有组织列表
      gradedPermission: false, // 是否开启分级权限
      requestCache: {}, // 请求去重缓存：相同参数只请求一次
    }
  },
  props: {
    curSpace: {
      type:Object
    },
    isUserSpace: {
      type: Boolean
    },
    maxCount: {
      type: Number,
      default: 0
    },
    isCheck: {
      type: Boolean,
      default: false
    }
  },
  created () {
    const spaceId = this.$route.query.spaceid
    const spaceStatus = this.$route.query.space
    const upaceId = this.$route.query.upaceid
    const upaceStatus = this.$route.query.upace
    if (typeof(spaceId) !== 'undefined' || spaceStatus){
      this.isSpace = true
    }
    else if (typeof(upaceId) !== 'undefined' || upaceStatus){
      this.isUpace = true
    }
  },
  methods: {
    getRequestCacheKey(apiName, params = {}) {
      const normalizedParams = {}
      Object.keys(params || {}).sort().forEach(key => {
        normalizedParams[key] = params[key]
      })
      return `${apiName}:${JSON.stringify(normalizedParams)}`
    },
    dealShowName(node) {
      return getOrgShowName(node.data)
    },
    //来自父级，pargam为接口请求参数，setting为配置信息
    fromParent(pargam,setting){
      [...setting.checkedArr].forEach(element => {
        this.checkedKeys.push(element.organizationId)
      });
      console.log('setting==', setting, pargam)
      this.apiUrl = setting.apiurl
      this.checkedArr = setting.checkedArr
      this.onlyuser = setting.onlyUser
      this.option = setting.option && typeof setting.option == "string" ? JSON.parse(setting.option) : setting.option
      this.leaf = setting.leaf || false
      this.radio = setting.radio
      this.isLook = setting.isLook
      this.iManageIt = setting.iManageIt
      this.pargam = pargam || {}
      if (setting.gradedPermission && (setting.lookRMSIsOrg === 4 || setting.lookRMSIsOrg === 3)) {
        this.isLook = 6
      }
      this.gradedPermission = setting.gradedPermission
      this.isdoorMultiple = setting.isdoorMultiple === undefined ? true : setting.isdoorMultiple
      this.Visible = true
      if(setting.lookRMSIsOrg) this.lookRMSIsOrg = setting.lookRMSIsOrg
      if(setting.orgLabel) this.orgLabel = setting.orgLabel
      if(setting.orgEqual) this.orgEqual = setting.orgEqual
      this.getAllOrgList()
    },
    async fromParentSearch (val) {
      // this.$refs.tree.$data.store.lazy = !val//搜索内容filterText不为空的话，懒加载模式为false
      if (val) {
        let obj = {curpage: 0, pagesize: 0}
        obj.name = val
        const res = await this.ongetlist({},obj)//调用后台搜索接口
        console.log("this.allOrgList==",this.allOrgList,val);
        const li = this.allOrgList.filter(item=>{
          return item.name.indexOf(val) > -1 || getOrgShowName(item).indexOf(val) > -1
        })
        this.treeData = (res && res.length) || li.length ? this.mergeUniqueById(res, li, 'organizationId') : []
      } else {
        if (this.option) {
          this.treeData = this.orgRes(this.option)
        } else {
          this.treeData = []
          this.loadNode(this.node_had,this.resolve_had)
        }
      }
      this.checkedKeys = []
      this.checkedArr.forEach(item =>{
        this.checkedKeys.push(item.organizationId)
      })
    },
    async loadNode (node, resolve) {
      // 自定义组织查看范围
      if(this.option&&node.level === 0){
        let orglist = this.orgRes(this.option)
        return resolve(orglist)
      }
      let obj = {
        pid: node.data && node.data.organizationId ? node.data.organizationId : 0,
        curpage: 0,
        pagesize: 0
      }
      let resData = await this.ongetlist(node,obj)
      if (node.level === 0) {
        this.resolve_had = resolve
        if(this.orgEqual || this.orgLabel){
          // this.$refs.tree.$data.store.lazy = false
        }
        if (this.curSpace && this.isUserSpace && Object.keys(this.curSpace).length !== 0) {
          this.node_had = {
            level: 0,
            data: this.curSpace,
          }
          return resolve([this.curSpace])
        } else {
          this.node_had = node
          return resolve(resData)
        }        
      }
      resolve(resData)
    },
    ongetlist(node,obj){
      if (node.level===0) { // 初始化
        Object.assign(obj, this.pargam); // 两个对象合并
      }
      let that = this
      return new Promise(function (resolve) {
        if (that.apiUrl) { // 服务端
          // 从空间进入，需要传空间id
          if(that.isSpace){
            let spaceId = typeof(that.$route.query.spaceid) !== 'undefined' ? that.$route.query.spaceid : localStorage.getItem('spaceid')
            obj.spaceid = spaceId;
          }
          else if (that.isUpace) {
            let upaceId = typeof(that.$route.query.upaceid) !== 'undefined' ? that.$route.query.upaceid : localStorage.getItem('upaceid')
            obj.upaceid = upaceId
          }
          const cacheKey = that.getRequestCacheKey('getapiorganizationlist', obj)
          if (!that.requestCache[cacheKey]) {
            that.requestCache[cacheKey] = getapiorganizationlist({ ...obj }).then(res => that.orgRes(res.data || []))
          }
          that.requestCache[cacheKey].then(orglist => {
            resolve(orglist)
          }).catch(err => {
            delete that.requestCache[cacheKey]
            console.log('组织获取错误', err)
          })
        } else {
          if(that.orgEqual){
            const cacheKey = that.getRequestCacheKey('getequalorglist', {})
            if (!that.requestCache[cacheKey]) {
              that.requestCache[cacheKey] = getequalorglist().then(res => that.orgRes(res.data || []))
            }
            that.requestCache[cacheKey].then(orglist => {
              resolve(orglist)
            }).catch(err => {
              delete that.requestCache[cacheKey]
              console.log('组织获取错误', err)
            })
          }
          else{
            if(that.orgLabel && that.lookRMSIsOrg !== 4){
              obj.type = that.orgLabel
              if (node.level === 0) {
                delete obj.pid
              }
            }
            // 从空间进入，需要传空间id
            if(that.isSpace){
              let spaceId = typeof(that.$route.query.spaceid) !== 'undefined' ? that.$route.query.spaceid : localStorage.getItem('spaceid')
              obj.spaceid = spaceId;
            }
            else if (that.isUpace) {
              let upaceId = typeof(that.$route.query.upaceid) !== 'undefined' ? that.$route.query.upaceid : localStorage.getItem('upaceid')
              obj.upaceid = upaceId
            }
            if(that.isLook === 6) {
              obj.manage = 1
              if(node.level === 0) {
                delete obj.pid
              }
              if (node.level !== 0 && that.gradedPermission) {
                delete obj.manage
              }
              if(that.iManageIt && that.iManageIt.length > 0) {
                obj.deptIds = that.iManageIt.join(',')
              }
            }
            const cacheKey = that.getRequestCacheKey('getopenorganizationlist', obj)
            if (!that.requestCache[cacheKey]) {
              that.requestCache[cacheKey] = getopenorganizationlist({ ...obj }).then(res => that.orgRes(res.data || []))
            }
            that.requestCache[cacheKey].then(orglist => {
              console.log("orglist==",orglist)
              if (that.pargam.organizationId && that.pargam.organizationId===1) {
                // 如果这个等于1，那就是本部门不含子部门，那么需要吧当前的参数回传回去，放到option里面，给用户搜索使用
                that.$emit('handleSelect', 2, orglist)
              }
              resolve(orglist)
            }).catch(err => {
              delete that.requestCache[cacheKey]
              console.log('组织获取错误', err)
            })
          }          
        }
      })
    },
    orgRes(data) {
      let li = data.map(item => {
        if(this.isLook === 6 && !this.gradedPermission) {
          return {...item, leaf: true}
        } else {
          return this.leaf ? {...item, leaf: true} : item
        }
      })
      if (this.gradedPermission && this.lookRMSIsOrg === 4 && this.option) {
        li.filter(item => {
          return this.option.find(option => option.organizationId === item.organizationId)
        })
      }
      return li
    },
    // 获取全部数据，用于搜索
    getAllOrgList(){
      let obj = {
        curpage: 0,
        pagesize: 0
      }
      if(this.orgLabel){
        obj.type = this.orgLabel
      }
      // 从空间进入，需要传空间id
      if(this.isSpace){
        let spaceId = typeof(this.$route.query.spaceid) !== 'undefined' ? this.$route.query.spaceid : localStorage.getItem('spaceid')
        obj.spaceid = spaceId;
      }
      else if (this.isUpace) {
        let upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
        obj.upaceid = upaceId
      }
      if(this.isLook === 6) {
        obj.manage = 1
        if(this.iManageIt && this.iManageIt.length > 0) {
          obj.deptIds = this.iManageIt.join(',')
        }
      }
      getopenorganizationlist(obj).then(res => {
        let orglist = this.orgRes(res.data||[])
        this.allOrgList = orglist
      }).catch(err => {
        console.log('组织获取错误', err)
      })
    },
    mergeUniqueById(a, b, key = 'organizationId') {
      const seen = new Set(Array.isArray(a) ? a.map(x => x && x[key]) : [])
      const extra = (Array.isArray(b) ? b : []).filter(x => x && !seen.has(x[key]))
      return [...(Array.isArray(a) ? a : []), ...extra]
    },
    handleNodeClick(data, node) {
      console.log("handleNodeClick==",data, node);
      // 如果点击的是文字区域，则手动触发展开/折叠
      if (!data.isLeaf) {
        // 切换节点展开状态
        if (node.expanded) {
          node.collapse();
        } else {
          node.expand();
        }
      }
    },
    // 当前节点选择发生改变时候
    handleCheckChange(data, checked){
      if (checked) { 
        this.checkedArr.push(data)
      } else { 
        let index = this.checkedArr.findIndex(item =>{
          return item.organizationId===data.organizationId
        })
        this.checkedArr.splice(index,1)
      } 
      this.$emit('change-checked', this.checkedArr)
    },
    // 点击当前节点
    handleCurrentChange(node) {
      if (!node) return
      // 自定义组织查看范围+可选择标签
      if(this.lookRMSIsOrg === 4 && (this.orgLabel && node.type !== this.orgLabel)) return
      this.$emit('change-checked', [node])
      if (this.radio && !this.onlyuser) {        
        // 超过最大可选择数量时，删除roleId对应的值
        if((this.maxCount !== 0 && this.maxCount !== null) || (this.lookRMSIsOrg === 4 && node.type === this.orgLabel)){
          let checkedArrLen = this.checkedArr.length
          if(checkedArrLen < this.maxCount){
            let pushStatus = true
            this.checkedArr.forEach(item =>{
              console.log("item.organizationId",item.organizationId, node.organizationId);
              if(item.organizationId === node.organizationId) {
                pushStatus = false
                return
              }
            })
            if(pushStatus){
              this.checkedArr.push(node)
            }
          }
          else{
            // 当maxCount=1时，直接替换已选组织
            if(this.maxCount === 1) {
              console.log("node==",node)
              this.checkedArr.splice(0, this.checkedArr.length, node)
            } else {
              this.$message.error('最多只能选择' + this.maxCount + '个组织')
              return false
            }
          }
          
        }
        else{
          this.checkedArr.splice(0,this.checkedArr.length,node)
        }
      } else {
        this.$emit('handleSelect', 1, {curpage: 1, pagesize: 100, organizationId: node.organizationId})
      }
    }, 
    // 单个节点取消选中
    setCheckedNodes(node){
      const orgId = node && node.organizationId
      if (!orgId) return

      // 先同步内部数据，避免依赖 tree 事件触发（原地修改，保持与父组件引用一致）
      for (let i = this.checkedArr.length - 1; i >= 0; i -= 1) {
        if (this.checkedArr[i] && this.checkedArr[i].organizationId === orgId) {
          this.checkedArr.splice(i, 1)
        }
      }
      for (let i = this.checkedKeys.length - 1; i >= 0; i -= 1) {
        if (this.checkedKeys[i] === orgId) {
          this.checkedKeys.splice(i, 1)
        }
      }

      // 若节点已渲染，取消树上的勾选态
      if (this.$refs.tree) {
        this.$refs.tree.setChecked(orgId, false, true)
      }

      // 单选场景补充清理当前高亮节点
      if (this.radio && !this.onlyuser && this.$refs.tree) {
        this.$refs.tree.setCurrentKey(null)
      }

      this.$emit('change-checked', this.checkedArr)
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    resetChecked() {
      this.checkedArr.splice(0,this.checkedArr.length)
      this.$refs.tree.setCheckedKeys([]);
    }
  },
	mounted() {

	}
}
</script>
<style lang="scss" scoped>
</style>
